import "./App.scss"
import React from "react"
import { ProfilePage } from "./components/ProfilePage"

function App() {
  return <ProfilePage />
}
export default App
